import PropTypes from 'prop-types'

const IconCheck = ({ style }) => {
  return (
    <svg viewBox="0 0 32 32" fill="none" style={style}>
      <mask id="mask_check" style={{ maskType: 'alpha' }} maskUnits="userSpaceOnUse" x="0" y="0" width="32" height="32">
        <rect width="32" height="32" fill="#D9D9D9"/>
      </mask>
      <g mask="url(#mask_check)">
        <path d="M12.733 20.2L24.033 8.9C24.2996 8.63333 24.6107 8.5 24.9663 8.5C25.3219 8.5 25.633 8.63333 25.8996 8.9C26.1663 9.16667 26.2996 9.48333 26.2996 9.85C26.2996 10.2167 26.1663 10.5333 25.8996 10.8L13.6663 23.0667C13.3996 23.3333 13.0885 23.4667 12.733 23.4667C12.3774 23.4667 12.0663 23.3333 11.7996 23.0667L6.0663 17.3333C5.79963 17.0667 5.67185 16.75 5.68296 16.3833C5.69407 16.0167 5.83296 15.7 6.09963 15.4333C6.3663 15.1667 6.68296 15.0333 7.04963 15.0333C7.4163 15.0333 7.73296 15.1667 7.99963 15.4333L12.733 20.2Z" fill="white"/>
      </g>
    </svg>
  )
}

IconCheck.propTypes = {
  style: PropTypes.object,
}

export default IconCheck
